module.exports = __webpack_public_path__ + "static/media/YB5F02_3.ca8c5cfc.jpg";